import { produce } from 'immer';

import { ActionType } from './types';

export interface SnackbarState {
  type: 'SUCCESS' | 'ERROR' | 'WARNING';
  message: string;
}

const initialState: SnackbarState = {
  type: 'ERROR',
  message: '',
};

const snackbarReducer = produce((draft: SnackbarState, action) => {
  const { payload } = action;
  switch (action.type) {
    case ActionType.SNACKBAR_SHOW:
      draft.type = payload.type;
      draft.message = payload.message;
      break;
    case ActionType.SNACKBAR_DISMISS:
      draft.message = '';
      break;
  }
}, initialState);

export default snackbarReducer;
